import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ORingDesignTechnicalIndexComponent } from './o-ring-design-technical-index.component';

const routes: Routes = [
  {
    path: '',
    component: ORingDesignTechnicalIndexComponent,
    data: {
      meta: {
        title: 'O-Ring Reference Guide | Marco Sealing Solutions (formerly Marco Rubber)',
        description: "Unsure what o-ring or sealing solution is best for you? Explore Marco's extensive o-ring reference guides, industry guides, and application guides."
      }
    }
  }
];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class ORingDesignTechnicalIndexRoutingModule { }
